/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ConnextSN,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetConnextIdBySnInput {
  sn?: string;
}
const build = (_query: DocumentNode, input: GetConnextIdBySnInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.sn !== undefined ? `$sn: String = ${JSON.stringify(input.sn).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getConnextIdBySn(
      ${ input.sn !== undefined ? 'sn: $sn,' : '' }
    ){
      ...connextsn
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetConnextIdBySnQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextsn on ConnextSN { ... }
   */
  async execute(_query: DocumentNode, input: GetConnextIdBySnInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getConnextIdBySn: Partial<ConnextSN> }>({ query: build(_query, input), fetchPolicy });
  }
}
